import { ReactElement } from "react";
import { Typography } from "@mui/material";
interface Props {
  onClick(): void;
  title: string;
  Icon: any;
  disabled?: boolean;
}

function TextButton({ onClick, title, Icon, disabled = false }: Props): ReactElement {
  const handleClick = () => {
    if (disabled) return
    onClick()
  }
  return (
    <div
      onClick={handleClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {Icon && <Icon />}
      <Typography style={{ fontSize: 14, marginLeft: 10 }}>{title}</Typography>
    </div>
  );
}

export default TextButton;
